import React from 'react';
import { Input, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { capitalize, compact, replace, isNumber, isFunction, toLower, isEqual } from 'lodash';
const findIcon = (count, error) => {
  if (error) {
    return 'close';
  }
  return isNumber(count) ? 'check' : 'search';
};
const externalIconStyle = {
  color: '#20c49e',
};
/*
Regex to extract ids or pages in either of the following formats:
  www.facebook.com/pages/Post-Planner/5478569871236
  www.facebook.com/PostPlanner
*/
const FACEBOOK_REGEX = /^(?:https?:\/\/)?(?:www\.|m\.|touch\.)?(?:facebook\.com|fb(?:\.me|\.com))\/(?!$)(?:(?:\w)*#!\/)?(?:pages\/)?(?:photo\.php\?fbid=)?(?:[\w\-]*\/)*?(?:\/)?(?:profile\.php\?id=)?([^\/?&\s]*)(?:\/|&|\?)?.*$/;
/*
  Regex to extrac ids for any page which is just
  blahblah.com/example
*/
const SIMPLE_REGEX = /\.com\/([^/\s#?]*)/;

const LINKEDIN_REGEX = /\.com\/in\/([^/\s#?]*)/;

const YOUTUBE_REGEX = /\.com\/(?:user\/|channel\/|@)?([^/\s#?]*)/;

const TWITCH_REGEX = /\.tv\/([^/\s#?]*)?/;

const TIKTOK_REGEX = /@([^/\s#?]*)?/;

const TELEGRAM_REGEX = /https:\/\/t\.me\/([^/\s#?]*)?/;

class NetworkHandleInput extends React.Component {
  constructor({ value }) {
    super();
    this.state = {
      timeout: undefined,
      value,
    };
  }

  networkHandleRegex = {
    facebook: FACEBOOK_REGEX,
    instagram: SIMPLE_REGEX,
    twitter: SIMPLE_REGEX,
    youtube: YOUTUBE_REGEX,
    linkedin: LINKEDIN_REGEX,
    twitch: TWITCH_REGEX,
    tiktok: TIKTOK_REGEX,
    telegram: TELEGRAM_REGEX,
  };

  handleChange = (e, v) => {
    clearTimeout(this.state.timeout);
    const timeout = setTimeout(() => {
      const { onChange, network } = this.props;
      const regex = this.networkHandleRegex[network];
      console.log(regex, v);
      if (regex) {
        const handleMatches = isFunction(regex) ? regex(v.value) : compact(regex.exec(v.value));
        const handle = handleMatches[1] || replace(v.value, /@/, '');
        const value = !isEqual(network, 'youtube') ? toLower(handle) : handle;
        console.log(value);
        this.setState({ value });
        onChange(e, { ...v, value });
      } else {
        onChange(e, v);
      }
    }, 1000);
    this.setState({ timeout, value: v.value });
  };

  keyPressUpdate = (e, v) => {
    console.log(e, v);
    this.setState({ value: v.value });
    // if (e.keyCode === 13) {
    //   this.handleChange(e, v);
    // }
  };

  render = () => {
    const { network, error, loading, count, disabled, readOnly, fluid, target, to, as, isPersonalPage, fromComponent, placeholder } = this.props;
    const { value } = this.state;
    const linkIcon = <Icon name="external" basic circular style={externalIconStyle} />;
    const fromSignUp = fromComponent === 'signup';

    if (fromSignUp) {
      return (
        <Input
          placeholder={placeholder || `${capitalize(network)} handle`}
          // icon={(to && readOnly) ? linkIcon : findIcon(isPersonalPage ? 1 : count, error)}
          // loading={loading}
          name={network}
          action={{
            color: 'teal',
            content: loading ? null : 'look up',
            icon: loading ? 'circle notched loading' : null,
            onClick: this.handleChange,
            name: network,
            value,
          }}
          value={value}
          onChange={this.keyPressUpdate}
          label={!readOnly && '@'}
          error={error && network}
          disabled={disabled}
          readOnly={readOnly}
          fluid={fluid}
          target={target}
          to={to}
          as={as}
        />
      );
    }

    return (
      <Input
        placeholder={placeholder || `${capitalize(network)} handle`}
        icon={(to && readOnly) ? linkIcon : findIcon(isPersonalPage ? 1 : count, error)}
        loading={loading}
        name={network}
        onChange={this.handleChange}
        value={value}
        label={!readOnly && '@'}
        error={error && network}
        disabled={disabled}
        readOnly={readOnly}
        fluid={fluid}
        target={target}
        to={to}
        as={as}
      />
    );
  }
}

NetworkHandleInput.propTypes = {
  network: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  fluid: PropTypes.bool,
  target: PropTypes.string,
  as: PropTypes.object,
  to: PropTypes.string,
  fromComponent: PropTypes.string,
};
NetworkHandleInput.defaultProps = {
  value: '',
  disabled: false,
  readOnly: false,
  fluid: false,
  target: undefined,
  as: undefined,
  to: undefined,
  fromComponent: '',
};

export default NetworkHandleInput;



/** WEBPACK FOOTER **
 ** ./src/components/network-handle-input/index.js
 **/